import { NgModule } from '@angular/core';
import { ProgressBarComponent } from './progress-bar/progress-bar';
import { IonTextAvatar } from './ion-text-avatar/ion-text-avatar';
import { TreeFolderComponent } from './tree-folder/tree-folder';
import { CommonModule } from '@angular/common';
import { IonicModule } from 'ionic-angular';

@NgModule({
	declarations: [
		IonTextAvatar,
		ProgressBarComponent,
		TreeFolderComponent
	],
	imports: [IonicModule, CommonModule],
	exports: [
		IonTextAvatar,
		ProgressBarComponent,
		TreeFolderComponent
	]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/components.module.ts